/*!
 * Copyright (c) Microsoft Corporation.
 * All rights reserved. See LICENSE in the project root for license information.
 */

import { Module } from '@msdyn365-commerce-modules/utilities';
import * as React from 'react';

import { IAccountGenericTileViewProps } from './account-generic-tile';

const AccountGenericTileView: React.FC<IAccountGenericTileViewProps> = props => {
    const { AccountGenericTile, heading, links } = props;

    return (
        <Module {...AccountGenericTile}>
            {heading}
            {links}
        </Module>
    );
};

export default AccountGenericTileView;
